import { DownloadOutlined } from '@ant-design/icons';
import { Button, Switch } from 'antd';
import { getApiExcel } from 'apis';
import { payrollApi } from 'Api/payroll';
import Ellipse from 'components/Global/Ellipse';
import RefreshComponent from 'components/Global/RefreshComponent';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { toastText } from 'utils/utils';
import { toggleUsdCurrency } from '../../../../redux/slices/usdCurrencyToggleSlice';
import styles from './index.module.scss';

type headerProps = {
	headerData: any;
	toggleRequired?: boolean;
	Payslip?: boolean;
	//onDownloadPayslips?: () => void;
	selectedPaySlips?: any;
	selectedPayrollId?: string;
	fetchAllData?: any;
	isLoading?: any;
	NetPay?: boolean;
};

const Header = ({
	headerData,
	NetPay,
	Payslip,
	toggleRequired,
	selectedPaySlips,
	selectedPayrollId,
	fetchAllData,
	isLoading,
}: headerProps) => {
	const { isUsdCurrency, usdCurrencyToggle } = useSelector(
		(state: any) => state.usdCurrencyToggle
	);

	const dispatch = useDispatch<AppDispatch>();
	const [isDownLoading, setIsDownLoading] = useState(false);
	const [isExportEarningsLoading, setIsExportEarningsLoading] =
		useState(false);
	const handleCurrencyChange = () => {
		dispatch(toggleUsdCurrency());
	};

	// const downloadSelectedPayslips = async () => {
	// 	if (!selectedPayrollId || selectedPaySlips.length === 0) {
	// 		toastText(
	// 			'Payroll ID and selected payslip IDs are required',
	// 			'error'
	// 		);
	// 		return;
	// 	}
	// 	try {
	// 		setIsDownLoading(true);

	// 		for (let i = 0; i < selectedPaySlips.length; i++) {
	// 			const payload = {
	// 				payrollId: selectedPayrollId,
	// 				payrollEmployeeId: selectedPaySlips[i],
	// 			};

	// 			const response = await getApiExcel(
	// 				'/payroll/download/multiselected-payslip',
	// 				payload
	// 			);

	// 			if (response && response.data) {
	// 				const pdfBlob = new Blob([response.data], {
	// 					type: 'application/pdf',
	// 				});

	// 				const pdfUrl = URL.createObjectURL(pdfBlob);
	// 				const link = document.createElement('a');
	// 				link.href = pdfUrl;
	// 				link.setAttribute('download', 'payslips.pdf');
	// 				document.body.appendChild(link);
	// 				link.click();
	// 				document.body.removeChild(link);
	// 			}
	// 		}

	// 		toastText('Payslips downloaded successfully', 'success');
	// 		//		setSelectedPayslipIds([]);
	// 	} catch (error: any) {
	// 		const message =
	// 			error.response?.data?.message || 'Failed to download payslips';
	// 		toastText(message, 'error');
	// 	} finally {
	// 		setIsDownLoading(false);
	// 	}
	// };

	const downloadSelectedPayslips = async () => {
		if (!selectedPayrollId || selectedPaySlips.length === 0) {
			toastText(
				'Payroll ID and selected payslip IDs are required',
				'error'
			);
			return;
		}
		try {
			setIsDownLoading(true);

			for (let i = 0; i < selectedPaySlips.length; i++) {
				const payload = {
					payrollId: selectedPayrollId,
					payrollEmployeeId: selectedPaySlips[i].payrollEmployeeId,
				};

				const response = await getApiExcel(
					'/payroll/download/multiselected-payslip',
					payload
				);

				if (response && response.data) {
					const periodName =
						headerData.payPeriodName.match(/^(.*?)\s*\(/)?.[1] ||
						'';
					const contentDisposition =
						response.headers['content-disposition'];
					let fileName = `${selectedPaySlips[
						i
					]?.employeeName?.replace(
						/\s+/g,
						' '
					)} ${periodName} Payslip.pdf`;
					if (contentDisposition) {
						const fileNameMatch =
							contentDisposition.match(/filename="(.+)"/);
						if (fileNameMatch.length === 2) {
							fileName = fileNameMatch[1];
						}
					}

					const pdfBlob = new Blob([response.data], {
						type: 'application/pdf',
					});

					const pdfUrl = URL.createObjectURL(pdfBlob);
					const link = document.createElement('a');
					link.href = pdfUrl;
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			}

			toastText('Payslips downloaded successfully', 'success');
		} catch (error: any) {
			const message =
				error.response?.data?.message || 'Failed to download payslips';
			toastText(message, 'error');
		} finally {
			setIsDownLoading(false);
		}
	};

	const exportEarningsExcel = async () => {
		if (!selectedPayrollId) {
			toastText('Payroll ID is required', 'error');
			return;
		}
		try {
			setIsExportEarningsLoading(true);
			const response =
				await payrollApi.exportPayrollEmployeeEarningsExcel(
					selectedPayrollId
				);

			if (response && response.data) {
				const periodName =
				headerData.payPeriodName.match(/^(.*?)\s*\(/)?.[1] ||
				'';
				let fileName = `${periodName} Payroll_Earnings.xlsx`;

				const excelBlob = new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});

				const excelUrl = URL.createObjectURL(excelBlob);
				const link = document.createElement('a');
				link.href = excelUrl;
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(excelUrl);

				toastText('Earnings Excel exported successfully', 'success');
			}
		} catch (error: any) {
			let errorMessage =
				'Something went wrong in exporting earnings excel';

			if (error?.response?.data instanceof ArrayBuffer) {
				try {
					const decoder = new TextDecoder('utf-8');
					const jsonString = decoder.decode(error.response.data);
					const parsedData = JSON.parse(jsonString);
					if (parsedData.message) {
						errorMessage = parsedData.message;
					}
				} catch (parseError) {
					// If parsing fails, use default message
				}
			} else if (error?.response?.data?.message) {
				errorMessage = error.response.data.message;
			} else if (error?.message) {
				errorMessage = error.message;
			}

			toastText(errorMessage, 'error');
		} finally {
			setIsExportEarningsLoading(false);
		}
	};

	return (
		<>
			<div className={styles['global-header']}>
				<div className={styles['inline-container']}>
					<div className={styles['inline-label']}>
						<p className={styles['label']}>Pay Period:</p>
						<p className={styles['label-value']}>
							{' '}
							<Ellipse
								maxLength={20}
								message={headerData?.payPeriodName}
								isTooltip={true}
								key={headerData?.payPeriodName}
								tooltipMessage={headerData?.payPeriodName}
							/>
						</p>
					</div>
					<div className={styles['inline-label']}>
						<p className={styles['label']}>Pay Group:</p>
						<p className={styles['label-value']}>
							{' '}
							<Ellipse
								maxLength={20}
								message={headerData?.payGroupNames}
								isTooltip={true}
								key={headerData?.payGroupNames}
								tooltipMessage={headerData?.payGroupNames}
							/>
						</p>
					</div>
					<div className={styles['inline-label']}>
						<p className={styles['label']}>Currency:</p>
						<p className={styles['label-value']}>
							{' '}
							<Ellipse
								maxLength={20}
								message={headerData?.currency}
								isTooltip={true}
								key={headerData?.currency}
								tooltipMessage={headerData?.currency}
							/>
						</p>
					</div>
					<div className={styles['inline-label']}>
						<p className={styles['label']}>Department:</p>
						<p className={styles['label-value']}>
							{' '}
							<Ellipse
								maxLength={20}
								message={headerData?.payGroupDepartment}
								isTooltip={true}
								key={headerData?.payGroupDepartment}
								tooltipMessage={headerData?.payGroupDepartment}
							/>
						</p>
					</div>
					<div className={styles['inline-label']}>
						<p className={styles['label']}>Branch:</p>
						<p className={styles['label-value']}>
							{' '}
							<Ellipse
								maxLength={20}
								message={headerData?.payGroupBranch}
								isTooltip={true}
								key={headerData?.payGroupBranch}
								tooltipMessage={headerData?.payGroupBranch}
							/>
						</p>
					</div>
					{isUsdCurrency && (
						<>
							<div className={styles['inline-label']}>
								<p className={styles['label']}>
									Conversion Rate:
								</p>
								<p className={styles['label-value']}>
									{' '}
									{headerData?.conversionRate}
								</p>
							</div>
						</>
					)}
					{headerData?.employeeLength > 0 && (
						<div className={styles['inline-label']}>
							<p className={styles['label']}>
								No. of Employees:{' '}
							</p>
							<p className={styles['label-value']}>
								{' '}
								<Ellipse
									maxLength={20}
									message={headerData.employeeLength}
									isTooltip={true}
									key={headerData?.employeeLength}
									tooltipMessage={headerData?.employeeLength}
								/>
							</p>
						</div>
					)}
				</div>
				<div className={styles['refresh-button-container']}>
					{!NetPay && !Payslip && (
						<div className={styles['refresh-button']}>
							<RefreshComponent
								isLoading={isLoading}
								fetchData={fetchAllData}
								title="Refresh all the Records"
							/>
						</div>
					)}
					{isUsdCurrency && toggleRequired && !Payslip && (
						<div className={styles.usdToggleContainer}>
							<p>{`Currency in ${
								!usdCurrencyToggle ? 'USD' : 'Kwacha'
							}`}</p>
							<Switch
								value={usdCurrencyToggle}
								onChange={handleCurrencyChange}
							/>
						</div>
					)}
				</div>
				{Payslip && selectedPaySlips.length > 0 && (
					<div className={styles['download-button-container']}>
						<Button
							type="primary"
							className={styles['download-slip-button']}
							onClick={downloadSelectedPayslips}
							loading={isDownLoading}
							disabled={isDownLoading}
						>
							<DownloadOutlined /> Download Pay Slip
						</Button>
					</div>
				)}
				{NetPay && selectedPayrollId && (
					<div className={styles['download-button-container']}>
						<Button
							type="primary"
							className={styles['download-slip-button']}
							onClick={exportEarningsExcel}
							loading={isExportEarningsLoading}
							disabled={isExportEarningsLoading}
						>
							<DownloadOutlined /> Export Earnings Excel
						</Button>
					</div>
				)}
			</div>
		</>
	);
};

export default Header;
